import { ReactElement } from 'react'

import SignInImpl from '../../domain/usecases/SignInImpl'
import { useAuth } from '../../hooks/auth'
import AuthRepository from '../../infra/repositories/AuthRepository'
import SignIn from '../../pages/SignIn'

export const SignInFactory = (): ReactElement => {
  const authRepository = new AuthRepository()
  const signInImpl = new SignInImpl(authRepository)

  const { signIn } = useAuth()
  return <SignIn signIn={signInImpl} signInStore={signIn} />
}
